import React from 'react';
import './index.css';

const RefundPolicyPage = () => {
    return (
        <div className="policy-page-container">
            <h1>🔁 REFUND POLICY — NOTTSIFY</h1>

            <h2>Refunds allowed only if:</h2>
            <ul>
                <li>Payment deducted but credits not credited</li>
                <li>Duplicate payment</li>
            </ul>

            <h2>No refunds if:</h2>
            <ul>
                <li>Credits used</li>
                <li>Subscription period already active</li>
            </ul>
        </div>
    );
};

export default RefundPolicyPage;
